module.exports = __webpack_public_path__ + "static/media/Lato-Black.33d5f0d9.woff2";